/**
 * Sprint P32 · Rich block-tooltip rows (renders inside a hover-panel).
 */

export function BlockTooltipRows({ b, cutoff, unit }) {
  if (!b) return null;
  const rows = [
    ["Easting", b.x?.toFixed?.(1)],
    ["Northing", b.y?.toFixed?.(1)],
    ["Elevation", b.z?.toFixed?.(1)],
    ["Grade", b.grade != null ? `${Number(b.grade).toFixed(3)} ${unit}` : "—"],
    ["Tonnage", b.tonnes != null ? Math.round(b.tonnes).toLocaleString() + " t" : "—"],
    ["Classification", b.classification || "—"],
    ["Domain", b.domain || "—"],
    ["Lithology", b.lithology || "—"],
    ["Samples", b.n_samples ?? "—"],
    ["Boreholes", b.n_holes ?? "—"],
    ["Est. pass", b.used_pass ?? "—"],
    ["Distance", b.search_distance_used != null ? Number(b.search_distance_used).toFixed(1) + " m" : "—"],
    ["Status", b.grade >= cutoff ? "ORE" : "WASTE"],
  ];
  return (
    <div className="grid grid-cols-2 gap-x-3 gap-y-0.5">
      {rows.map(([k, v]) => (
        <div key={k} className="contents">
          <span className="text-slate-400">{k}</span>
          <span className={"text-right " + (k === "Status"
            ? (v === "ORE" ? "text-emerald-400 font-bold" : "text-slate-400")
            : "text-slate-100")}>{v}</span>
        </div>
      ))}
    </div>
  );
}
